import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetRemoteLockConnectionRequest = {
  buildingId: number
}

export type RemoteLockDoorRef = { id: string; name: string }

export type RemoteLockConnection = {
  shouldAutoAssignApartmentDoorVisitor: boolean
  staffDefaults: RemoteLockDoorRef[]
  visitorDefaults: RemoteLockDoorRef[]
}

export const getRemoteLockConnectionQueryKey = (data: GetRemoteLockConnectionRequest) => [
  'useGetRemoteLockConnection',
  data,
]

const getRemoteLockConnection = async (data: GetRemoteLockConnectionRequest) => {
  const response = await authAPI.get<RemoteLockConnection>(
    `/building/${data.buildingId}/remote-lock/integration`,
  )
  return response.data
}

export const useGetRemoteLockConnection = (data: GetRemoteLockConnectionRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getRemoteLockConnection(data),
    queryKey: getRemoteLockConnectionQueryKey(data),
  })
